export const accountKey = {
    me: [{ scope: 'account' }] as const,
}
